import { axios } from '@/plugins/axios'
import { IContactModel } from '@/models/contact'

export const sendContactInfo = async (data: IContactModel, domain: string) => {
  await axios.post('/contact/', {
    ...data,
    from_url: domain,
  })
}
